"use client";

import { Shield } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PrivacyOverview() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section className="bg-[hsl(212,15%,95%)] py-16 px-4">
      <div className="container mx-auto max-w-3xl">
        <div ref={ref} className={`transition-all duration-200 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <Card className="bg-white shadow-[0_1px_2px_rgba(0,0,0,0.05)] border-none">
            <CardHeader className="relative">
              <div className="absolute top-0 left-0 p-6">
                <Shield className="w-6 h-6 text-[hsl(215,65%,45%)]" strokeWidth={1.5} />
              </div>
              <CardTitle className="text-[hsl(215,65%,45%)] text-2xl font-semibold text-center pt-8">
                Privacy Overview
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-[hsl(210,10%,15%)] text-base leading-relaxed text-center">
                We are committed to protecting your privacy and ensuring the security of your personal information. Our privacy practices comply with industry standards and regulations to safeguard your data throughout our services.
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}